// we don't need to use a variable
// or the from keyword when importing a css/styl file
// thanks the the styles loader it gets added as a
// <style> tag in the head by default but can be changed
import 'normalize.css';
import '../styles/styles';
import 'jquery';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
// import angularUIBootstrap from 'angular-ui-bootstrap';

import {AppComponent} from './app.component.js';
import {components} from './components/components.js';
import {models} from './models/models.js';
import {config} from './config.js';
import {run} from './config.js';


//Loads the correct sidebar on window load,
//collapses the sidebar on window resize.
// Sets the min-height of #page-wrapper to window size
$(document).ready(function () {

    // Append config box / Only for demo purpose
    //$.get("views/skin-config.html", function (data) {
    //    $('body').append(data);
    //});

    // Full height of sidebar
    // function fix_height() {
    //     var heightWithoutNavbar = $("body > #wrapper").height() - 61;
    //     $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    //     var navbarHeigh = $('nav.navbar-default').height();
    //     var wrapperHeigh = $('#page-wrapper').height();

    //     if(navbarHeigh > wrapperHeigh){
    //         $('#page-wrapper').css("min-height", navbarHeigh + "px");
    //     }

    //     if(navbarHeigh < wrapperHeigh){
    //         $('#page-wrapper').css("min-height", $(window).height()  + "px");
    //     }

    //     if ($('body').hasClass('fixed-nav')) {
    //         if (navbarHeigh > wrapperHeigh) {
    //             $('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
    //         } else {
    //             $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
    //         }
    //     }

    // }


    // $(window).bind("load resize scroll", function() {
    //     if(!$("body").hasClass('body-small')) {
    //         fix_height();
    //     }
    // });

    // Move right sidebar top after scroll
    $(window).scroll(function(){
        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav') ) {
            $('#right-sidebar').addClass('sidebar-top');
        } else {
            $('#right-sidebar').removeClass('sidebar-top');
        }
    });


    // setTimeout(function(){
    //     fix_height();
    // });
});

// Minimalize menu when screen is less than 768px
$(function() {
    $(window).bind("load resize", function() {
        if ($(document).width() < 769) {
            $('body').addClass('body-small');
        } else {
            $('body').removeClass('body-small');
        }
    });
});

// console.log(angularUIBootstrap);

const app = angular.module('app', [
  uiRouter,
  models.name,
  components.name
]);

app.config(config);
app.run(run);
app.component('app', AppComponent);



// WEBPACK FOOTER //
// ./app/app.js